import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SessionManager } from '../utils/sessionManager';
import { authAPI } from '../services/api';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const user = SessionManager.getUser();
  const isLoggedIn = SessionManager.isSessionValid();

  const handleLogout = async () => {
    try {
      await authAPI.logout();
      navigate('/');
    } catch (error) {
      // console.error('Logout error:', error);
      SessionManager.clearSession();
      navigate('/');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          Microvista KYC
        </Link>

        <div className="navbar-menu">
          {isLoggedIn ? (
            <>
              <Link to="/dashboard" className="navbar-link">
                Dashboard
              </Link>
              <Link to="/history" className="navbar-link">
                History
              </Link>
              {user?.role !== 'Admin' && (
                <Link to="/buy-credits" className="navbar-link">
                  Buy Credits
                </Link>
              )}
              {user?.role === 'Admin' && (
                <Link to="/admin" className="navbar-link">
                  Admin
                </Link>
              )}
              <div className="navbar-user">
                <span>{user?.firstName} {user?.lastName}</span>
                <span className="credits">₹{user?.creditsRemaining || 0}</span>
              </div>
              <button onClick={handleLogout} className="navbar-button">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/" className="navbar-link">
                Login
              </Link>
              <Link to="/register" className="navbar-button">
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
